import RtlProvider from "@mui/system/RtlProvider";
import type { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";

/**
 * Tells the MUI components inside it the UI language's reading direction. The app flips `dir` on `<body>` but never sets
 * `theme.direction` or an `RtlProvider`, so MUI's own direction-aware maths (a scrollable `Tabs`' scroll buttons and
 * indicator) otherwise runs left-to-right in Hebrew. Wrap only the component that needs it.
 */
export const ReadingDirectionProvider: FC<{ children: ReactNode }> = ({ children }) => {
	const { i18n } = useTranslation();
	return <RtlProvider value={i18n.dir() === "rtl"}>{children}</RtlProvider>;
};
